import React from 'react'
import { DataRef } from '../../../../types/DataRef';

export const dataTypeConsolidation: DataRef[] = [
    { id: 1, libelle: "Annuelle" },
    { id: 2, libelle: "détail mensuel" },
  ];

export const dataConsildationPar: DataRef[] = [
    {id:1 ,libelle:"Client"},
    {id:2 ,libelle:"Operation"}
];

export interface IConsolidationCommission {
  id: number
  name: string
  email: string
  prenom: string
  herConsolidationparType: IHerConsolidationParType[]
  devise_commission: DeviseCommission
}

interface DeviseCommission {
  id: number
  monnaie: string
  symbole: string
  code_iso: string
}

export interface IHerConsolidationParType {
  Annee: number
  Mois: number
  operation: string
  client: string
  ca: number
  Commission: number
  // Commission_Devise: string
  userId: number
}




